import React from 'react';
import Icon from '../../../components/AppIcon';

const LearningStats = ({ stats }) => {
  const statItems = [
    {
      icon: 'Target',
      label: 'Missions Completed',
      value: stats?.missionsCompleted,
      total: stats?.totalMissions,
      color: 'var(--color-success)',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Flame',
      label: 'Learning Streak',
      value: `${stats?.currentStreak} days`,
      subtitle: `Best: ${stats?.bestStreak} days`,
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    },
    {
      icon: 'Clock',
      label: 'Total Practice Time',
      value: `${Math.floor(stats?.totalPracticeTime / 60)}h ${stats?.totalPracticeTime % 60}m`,
      subtitle: 'This month',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'Award',
      label: 'Achievements',
      value: stats?.achievementsEarned,
      total: stats?.totalAchievements,
      color: 'var(--color-secondary)',
      bgColor: 'bg-secondary/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {statItems?.map((item, index) => (
        <div key={index} className="bg-card rounded-lg border border-subtle p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${item?.bgColor} flex items-center justify-center`}>
              <Icon name={item?.icon} size={24} color={item?.color} />
            </div>
            {item?.total && (
              <div className="text-right">
                <div className="text-xs text-muted-foreground">Progress</div>
                <div className="text-sm font-medium text-foreground">
                  {Math.round((item?.value / item?.total) * 100)}%
                </div>
              </div>
            )}
          </div>
          
          <div className="space-y-1">
            <h3 className="text-sm font-medium text-muted-foreground">{item?.label}</h3>
            <div className="flex items-baseline gap-1">
              <span className="text-2xl font-bold text-foreground">
                {typeof item?.value === 'string' ? item?.value : item?.value?.toLocaleString()}
              </span>
              {item?.total && (
                <span className="text-sm text-muted-foreground">
                  / {item?.total?.toLocaleString()}
                </span>
              )}
            </div>
            {item?.subtitle && (
              <p className="text-xs text-muted-foreground">{item?.subtitle}</p>
            )}
          </div>

          {item?.total && (
            <div className="mt-4">
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full transition-all duration-500"
                  style={{
                    width: `${Math.min((item?.value / item?.total) * 100, 100)}%`,
                    backgroundColor: item?.color
                  }}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default LearningStats;